import { render } from "./PedidoView.vue?vue&type=template&id=e67a463a&scoped=true"
import script from "./PedidoView.vue?vue&type=script&lang=js"
export * from "./PedidoView.vue?vue&type=script&lang=js"

import "./PedidoView.vue?vue&type=style&index=0&id=e67a463a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e67a463a"

export default script